import { SelectedFile, SelectedFileStatus } from '@vizit/atoms';
import * as React from 'react';
import type { UploadQueueItemData } from './provider';

interface UploadQueueItemProps {
  /**
   * The queue item to display
   * @type {UploadQueueItemData}
   */
  item: UploadQueueItemData;
  /**
   * Callback when the item is removed
   * @type {(id: string) => void}
   */
  onRemove: (id: string) => void;
}

/**
 * Renders a single item in the upload queue
 */
function UploadQueueItem(props: UploadQueueItemProps) {
  const { item, onRemove } = props;

  const handleRemove = React.useCallback(() => {
    onRemove(item.id);
  }, [item.id, onRemove]);

  const showProgress = item.status === SelectedFileStatus.Uploading || item.status === SelectedFileStatus.Ready;

  return (
    <SelectedFile
      condensed
      file={item.file}
      status={item.status}
      showProgress={showProgress}
      progressValue={item.progress}
      onRemove={item.status !== SelectedFileStatus.Uploading ? handleRemove : undefined}
    />
  );
}

export { UploadQueueItem };
export type { UploadQueueItemProps };
